import { StockEnquiryPurchaseOrder } from './stock-enquiry-purchase-order';
import { StockItemProductEnquiry } from './stock-item-product-enquiry';
import { StockEnquirySalesOrder } from './stock-enquiry-sales-order';
import { SupplierProduct } from '../purchasing';

export interface StockEnquiryByProduct {
  id: string;
  productKey: string;
  productDescription: string;
  oldCode: string;
  customerKey: string;
  productTypeDescription: string;
  defaultSupplier: string;
  defaultSupplierName: string;
  unitOfMeasure: string;
  unitOfMeasureShortDescription: string;
  productGroup: string;
  composition: string;
  tariffCode: string;
  totalStock: string;
  physicalStock: string;
  poAllocated: string;
  allocated: string;
  freeStock: string;
  required: string;
  onOrder: string;
  available: string;
  secondStock: string;
  largestBatch: number;
  supplierKey: string;
  supplierName: string;
  supplierPartNo: string;
  supplierStdPrice: number;
  calculatedStdCost: number;
  supplierCurrencyCode: string;
  supplierCurrencySymbol: string;
  clearanceProduct: string;
  balance: number;
  unAllocated: number;
  billOfMaterials: boolean;
  comments: string;
  externalNo: string;
  minimumStockLevel: number;
  minimumOrderQuantity: number;
  glm: number;
  gsm: string;
  width: number;
  freeBalance: number;
  freePOBalance: number;

  stockItems: StockItemProductEnquiry[];
  purchaseOrders: StockEnquiryPurchaseOrder[];
  salesOrders: StockEnquirySalesOrder[];
  supplierProducts: SupplierProduct[];
}
